import { render, staticRenderFns } from "./Sensors.vue?vue&type=template&id=b8375662&scoped=true&lang=html&"
import script from "./Sensors.vue?vue&type=script&lang=js&"
export * from "./Sensors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8375662",
  null
  
)

export default component.exports